var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-widget"},[_c('div',{staticClass:"white-card-header"},[_c('div',{staticClass:"header-left"},[_vm._t("header-left")],2),_c('div',{staticClass:"header-right"},[_vm._t("header-right")],2)]),_c('div',{staticClass:"white-card-body"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }